import { createContext, useContext, useState } from 'react'
import { equipmentService } from '../services/equipmentService'
import { useNavigate } from 'react-router'
import { useUtiles } from './utilesContext'
import * as XLSX from 'xlsx'
import Swal from 'sweetalert2'
export const EquipmentContext = createContext()

export const useEquipment = () => {
    return useContext(EquipmentContext)
}

export const EquipmentProvider = ({ children }) => {

    const navigate = useNavigate()
    const { setAlertSnackbar } = useUtiles()

    const [equipment, setEquipment] = useState({
        location: '',
        name: '',
        code: '',
        manufacturer: '',
        model: '',
        serial: '',
        type_equipment: '',
        date_acquisition: '',
        priority: '',
        classification1: '',
        classification2: '',
        out_of_service: false,
        enabled: true,
        notes: '',
        otro1: '',
        otro2: '',
    })

    const resetEquipment = () => {
        setEquipment({
            location: '',
            name: '',
            code: '',
            manufacturer: '',
            model: '',
            serial: '',
            type_equipment: '',
            date_acquisition: '',
            priority: '',
            classification1: '',
            classification2: '',
            out_of_service: false,
            enabled: true,
            notes: '',
            otro1: '',
            otro2: '',
        })
    }


    const setSelectLocationParent = (location) => {
        setEquipment( (prev) => ({ ...prev, location: location}))
    }

    const setSelectClassification1 = (classification) => {
        setEquipment( (prev) => ({ ...prev, classification1: classification}))
    }

    const setSelectClassification2 = (classification) => {
        setEquipment( (prev) => ({ ...prev, classification2: classification}))
    }

    const setSelectTypeEquipment = (typeEquipment) => {
        setEquipment( (prev) => ({ ...prev, type_equipment: typeEquipment}))
    }



    const [typeEquipments, setTypeEquipments] = useState([])
    const [loadingTypeEquipments, setLoadingTypeEquipments] = useState(false)
    const getTypeEquipments = async () => {
        try {
            setLoadingTypeEquipments(true)
            const response = await equipmentService.getTypeEquipments()
            setTypeEquipments(response.data)
            console.log(response.data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingTypeEquipments(false)
        }
    }

    const [loadingCreateTypeEquipment, setLoadingCreateTypeEquipment] = useState(false) 
    const createTypeEquipment = async (typeEquipment) => {
        try {
            setLoadingCreateTypeEquipment(true)
            const response = await equipmentService.createTypeEquipment(typeEquipment)
            await getTypeEquipments()
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingCreateTypeEquipment(false)
        }
    }

    /**
     * CREAR EQUIPO
     */

    const [loadingCreateEquipment, setLoadingCreateEquipment] = useState(false)
    const createEquipment = async () => {
        try {
            setLoadingCreateEquipment(true)

            //obtener solo los id de location, classification1, classification2 y type_equipment    
            const data = { ...equipment, 
                location: equipment.location ? equipment.location.id : null, 
                classification1: equipment.classification1 ? equipment.classification1.id : null, 
                classification2: equipment.classification2 ? equipment.classification2.id : null, 
                type_equipment: equipment.type_equipment ? equipment.type_equipment.id : null 
            }
            const response = await equipmentService.createEquipment(data)
            //await getEquipments()
            resetEquipment()
            navigate('/activos/equipos')
            setAlertSnackbar({
                open: true,
                message: 'Equipo creado correctamente',
                severity: 'success'
            })
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        } finally {
            setLoadingCreateEquipment(false)
        }   
    }

    /**
     * ACTUALIZAR EQUIPO
     */

    const [loadingUpdateEquipment, setLoadingUpdateEquipment] = useState(false)
    const updateEquipment = async () => {
        try {
            setLoadingUpdateEquipment(true)
            //obtener solo los id de location, classification1, classification2 y type_equipment    
            const data = { ...equipment, 
                location: equipment.location ? equipment.location.id : null, 
                classification1: equipment.classification1 ? equipment.classification1.id : null, 
                classification2: equipment.classification2 ? equipment.classification2.id : null, 
                type_equipment: equipment.type_equipment ? equipment.type_equipment.id : null 
            }
            const response = await equipmentService.updateEquipment(data)
            resetEquipment()
            navigate('/activos/equipos')
            setAlertSnackbar({
                open: true,
                message: 'Equipo actualizado correctamente',
                severity: 'success'
            })
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        } finally {
            setLoadingUpdateEquipment(false)
        }
    }

    /**
     * LISTAR EQUIPOS
     */

    const [loadingGetEquipments, setLoadingGetEquipments] = useState(false)
    const [equipments, setEquipments] = useState([])

    const [selectedEquipmentToDelete, setSelectedEquipmentToDelete] = useState([])
    const [pagination, setPagination] = useState({})
    const getEquipments = async (filters) => {
        try {
            setLoadingGetEquipments(true)
            const response = await equipmentService.getEquipments(filters)
            setEquipments(response.data.equipments)
            setPagination(response.data.pagination)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingGetEquipments(false)
        }
    }

    /**
     * CARGAR EQUIPOS MASIVOS
     */

    const [loadingUploadMasive, setLoadingUploadMasive] = useState(false)
    const [dataMasive, setDataMasive] = useState(null)
    const [responseMasive, setResponseMasive] = useState(null)

    const loadMasiveEquipments = async (files) => {
        try{
            setLoadingUploadMasive(true)    
            const file = files[0]
            const reader = new FileReader()

            reader.onload = (event) => {
                const arrayBuffer = event.target.result;
                const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const data = XLSX.utils.sheet_to_json(worksheet);

                // Convertir fechas de Excel a formato ISO (YYYY-MM-DD)
                const processedData = data.map(item => {
                    const newItem = { ...item };

                    // Procesar date_acquisition si existe y es un número (serial de Excel)
                    if (newItem.date_acquisition !== undefined && newItem.date_acquisition !== null) {
                        // Si es un número de serie de Excel
                        if (typeof newItem.date_acquisition === 'number' || !isNaN(Number(newItem.date_acquisition))) {
                            // Convertir el número de serie de Excel a una fecha JavaScript
                            const excelEpoch = new Date(1899, 11, 30); // Excel epoch (December 30, 1899)
                            const serialNumber = Number(newItem.date_acquisition);  
                            const daysSinceEpoch = serialNumber; // Excel usa días desde la fecha base

                            // Calcular la fecha sumando los días a la fecha base
                            const date = new Date(excelEpoch);
                            date.setDate(date.getDate() + daysSinceEpoch);

                            // Formatear la fecha en ISO YYYY-MM-DD
                            newItem.date_acquisition = date.toISOString().split('T')[0];
                        }
                    }
                    return newItem;
                });

                console.log(processedData)
                setDataMasive(processedData)

              };
              
              reader.readAsArrayBuffer(file);
        }catch(error){
            console.log(error)
        }finally{   
            setLoadingUploadMasive(false)
        }
    }

    const [loadingMasive, setLoadingMasive] = useState(false)
    const processMasiveEquipments = async () => {
        setLoadingMasive(true)
        try{
            
            const response = await equipmentService.postMasiveEquipments(dataMasive)
            setResponseMasive(response.data)
            setDataMasive(null)
            await getEquipments()


            setAlertSnackbar({
                open: true,
                message: "Equipos procesados correctamente",
                severity: 'success'
            })
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Ocurrió un error al procesar los equipos",
                severity: 'error'
            })
        }finally{
            setLoadingMasive(false)
        }
    }

    /**
     * ELIMINAR EQUIPOS
     */

    const [loadingDeleteEquipments, setLoadingDeleteEquipments] = useState(false)
    const deleteEquipments = async (ids) => {
        try{
            const confirm = await Swal.fire({
                title: '¿Estás seguro?',
                text: 'No podrás revertir esto',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
            })
            if(!confirm.isConfirmed){
                return
            }
            setLoadingDeleteEquipments(true)
            const response = await equipmentService.deleteEquipments(ids)
            await getEquipments()
            setSelectedEquipmentToDelete([])
            setAlertSnackbar({
                open: true,
                message: "Equipos eliminados correctamente",
                severity: 'success'
            })
        }catch(error){
            console.log(error)
        }finally{
            setLoadingDeleteEquipments(false)
        }
    }


    /**
     * OBTENER EQUIPO POR HASH
     */

    const [loadingGetEquipmentByHash, setLoadingGetEquipmentByHash] = useState(false)
    const getEquipmentByHash = async (hash) => {
        setLoadingGetEquipmentByHash(true)
        try{
            const response = await equipmentService.getEquipmentByHash(hash)
            setEquipment(response.data) 
            setAlertSnackbar({
                open: true,
                message: "Equipo obtenido correctamente",
                severity: 'success'
            })
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Ocurrió un error al obtener el equipo",
                severity: 'error'
            })
        }finally{
            setLoadingGetEquipmentByHash(false)
        }
    }

    return (
        <EquipmentContext.Provider value={{ 
            equipment, 
            setEquipment, 
            resetEquipment, 
            setSelectLocationParent, 
            setSelectClassification1, 
            setSelectClassification2, 
            typeEquipments, 
            getTypeEquipments, 
            loadingTypeEquipments,
            setSelectTypeEquipment,
            createTypeEquipment,
            loadingCreateTypeEquipment,
            setLoadingCreateTypeEquipment,
            createEquipment,
            loadingCreateEquipment,
            getEquipments,
            equipments,
            loadingGetEquipments,
            selectedEquipmentToDelete,
            setSelectedEquipmentToDelete,
            pagination,
            setPagination,
            loadingUploadMasive,
            dataMasive,
            responseMasive,
            loadMasiveEquipments,
            loadingMasive,
            processMasiveEquipments,
            deleteEquipments,
            loadingDeleteEquipments,
            setDataMasive,
            setResponseMasive,
            loadingGetEquipmentByHash,
            getEquipmentByHash,
            loadingUpdateEquipment,
            updateEquipment
        }}>
            {children}
        </EquipmentContext.Provider>
    )
}
